// @flow
import React, { type Node } from 'react';
import cn from 'classnames/bind';

import styles from './KlassSwitcherItem.scss';


const cx = cn.bind(styles);

export type Props = {
  id: string,
  title: string,
  schoolyearTitle: string,
  current?: boolean,
}

const KlassSwitcherItem = ({ title, schoolyearTitle, current }: Props): Node => {
  return (
    <div className={cx(styles.root, { current })}>
      <span className={styles.title}>{title}</span>
      <span className={styles.year}>{schoolyearTitle}</span>
    </div>
  );
};

export default KlassSwitcherItem;
